import { useParams, Navigate } from "react-router-dom";
import AtlasLayer from "./AtlasLayer";
import { externalLayer, skeletalLayer } from "./data/layers";
import { externalQuiz, skeletalQuiz } from "./data/quiz";

const LAYER_MAP = {
  "budowa-zewnetrzna": {
    layer: externalLayer,
    quiz: externalQuiz,
    seoTitle: "Budowa zewnętrzna owczarka niemieckiego — Atlas Anatomii | Wolfe vom Katzenberg",
    seoDesc: "Interaktywna mapa budowy zewnętrznej owczarka niemieckiego. 13 punktów anatomicznych z opisami, funkcją, znaczeniem hodowlanym i kryteriami oceny."
  },
  "uklad-kostny": {
    layer: skeletalLayer,
    quiz: skeletalQuiz,
    seoTitle: "Układ kostny owczarka niemieckiego — Atlas Anatomii | Wolfe vom Katzenberg",
    seoDesc: "Interaktywna mapa układu kostnego owczarka niemieckiego. Czaszka, kręgosłup, miednica, kości kończyn i stawy z opisami hodowlanymi."
  },
};

const AtlasLayerPage = () => {
  const { slug } = useParams();
  const data = LAYER_MAP[slug];

  if (!data) return <Navigate to="/anatomia/owczarek-niemiecki" replace />;

  return <AtlasLayer layer={data.layer} quiz={data.quiz} seoTitle={data.seoTitle} seoDesc={data.seoDesc} />;
};

export default AtlasLayerPage;
